export const pkg = {
  name: 'isomorphic-git',
  version: '1.37.4',
  agent: 'git/isomorphic-git@1.37.4',
}
